import { render } from "./ThinkHub.vue?vue&type=template&id=3ccc004b&lang=pug"
import script from "./ThinkHub.vue?vue&type=script&lang=js"
export * from "./ThinkHub.vue?vue&type=script&lang=js"

import "./ThinkHub.vue?vue&type=style&index=0&id=3ccc004b&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__